export enum SessionStateEventType {
  USER_FLOW_ACTION = 'USER_FLOW_ACTION',
  SYSTEM_FLOW = 'SYSTEM_FLOW',
  ERROR_REPORT = 'ERROR_REPORT',
  GRID_MODIFICATION = 'GRID_MODIFICATION',
  USER_EMOTION = 'USER_EMOTION',
  TEST = 'TEST',
}

export type SessionStateEvent = {
  sessionId: string;
  userId?: string | null;
  assignmentId?: string | null;
  clientTimestamp: string;
  platform: 'WEB' | 'UNITY' | 'AI' | 'UNKNOWN';
  appVersion?: string | null;
  severity: 'INFO' | 'WARN' | 'ERROR' | 'FATAL';
  eventType: SessionStateEventType;
  eventName: string;
  eventPayload?: Record<string, unknown>;
};
